module.exports = __webpack_public_path__ + "img/arrow.f5b711e8.svg";